import { UpdateNameConferenceUser } from 'domain/usecases/conferenceUser/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteUpdateNameConferenceUser
  implements UpdateNameConferenceUser
{
  private readonly url: string;

  private readonly httpClient: HttpClient<UpdateNameConferenceUser.Model>;

  constructor(
    url: string,
    httClient: HttpClient<UpdateNameConferenceUser.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  updateName = async (
    params: UpdateNameConferenceUser.Params,
  ): Promise<UpdateNameConferenceUser.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{confirmCode}', params.confirmCode),
      body: params.body,
      method: 'patch',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
